import axios from "axios";
import { IP_ADDRESS } from "../../config";
import { handleAxiosError } from "../error.handler.service";
export const getAllCompanies = async () => {
  try {
    const resp = await axios.get(`${IP_ADDRESS}/company`);
    return await resp.data;
    // const customers = await resp.data;
    // return await customers.data;
  } catch (err) {
    // Handle Error Here
    handleAxiosError(err);
  }
};

export const createCompany = async (companyData) => {
  try {
    const res = await axios.post(`${IP_ADDRESS}/company/authorization/create`, companyData);
    return res.data;
    
  } catch (err) {
    // Handle Error Here
    handleAxiosError(err);
  }
};

export const checkCompanyExists = async (company_name) => {
  try {
    const response = await axios.get(`${IP_ADDRESS}/company/authorization/exists`, { params: { company_name }});

    return response.data; 
  } catch (error) {
    console.error("Error checking company existence:", error);
    handleAxiosError(error);
  }
};


export const getCompanyLogos = async (companyList) => {
  try {
    const resp = await axios.get(
      `${IP_ADDRESS}/company/authorization/getLogo`,
      {
        params: { companyList: companyList },
      }
    );
    return resp.data;
    // const customers = await resp.data;
    // return await customers.data;
  } catch (err) {
    // Handle Error Here
    handleAxiosError(err);
  }
};
